module.exports = __webpack_public_path__ + "img/asian-beef-noodles-1.ab1bb8f9.jpg";